import React, { useEffect, useState } from "react";
import PaymentCard from "./PaymentCard";
import axios from "axios";
import { API_BASE_URL } from "../ApiConfig";
import { useNavigate } from "react-router-dom";
import { getSecureToken } from "../ApisService/apiService";

const Premium = () => {
    const [expiryDate, setExpiryDate] = useState(null);
    const [remainingDays, setRemainingDays] = useState(null);
    const [status, setStatus] = useState("loading");
    const navigate = useNavigate();

    useEffect(() => {
        const fetchSubscriptionStatus = async () => {
            try {
                // Retrieve email from localStorage
                const email = localStorage.getItem("userEmail");
                if (!email) {
                    setStatus("error");
                    return;
                }
          const { secrettoken, ts } = await getSecureToken();

                const response = await axios.get(`${API_BASE_URL}payment/check_plan.php`, {
                    params: { email },
                           headers: {
                        'X-TOKEN': secrettoken,
                        'X-TIMESTAMP': ts
                    },
                    withCredentials: true
                });

                const data = response.data;

                if (data.status === "active") {
                    const formattedDate = new Date(data.expiry_date).toISOString().split("T")[0];
                    setExpiryDate(formattedDate);
                    setRemainingDays(data.remaining_days);
                    setStatus("active");
                }else {
                    setStatus("expired");
                    // navigate("/payment_card");
                }
                
            } catch (error) {
                console.error("Error fetching subscription status:", error);
                setStatus("error");
            }
        };

        fetchSubscriptionStatus();
    }, []);

    return (
        <div className="container mb-5 mb-md-0">
            <div className="row justify-content-center align-items-center min-vh-80 text-center">
                <div className="col-md-6 d-flex flex-column align-items-center mt-3 mt-md-0">
                    <strong
                        style={{
                            color: "#fff",
                            fontSize: "18px",
                            fontWeight: "bold",
                            padding: "15px 25px",
                            borderRadius: "12px",
                            display: "inline-block",
                            background:
                                status === "active"
                                    ? "linear-gradient(90deg, #32cd32, #228b22)"
                                    : status === "expired"
                                        ? "linear-gradient(90deg, #ff4d4d, #b22222)"
                                        : status === "error"
                                            ? "linear-gradient(90deg, #ffa500, #ff8c00)"
                                            : "#ddd",
                            boxShadow:
                                status === "active"
                                    ? "0 0 15px rgba(50, 205, 50, 0.6)"
                                    : status === "expired"
                                        ? "0 0 15px rgba(255, 77, 77, 0.6)"
                                        : status === "error"
                                            ? "0 0 15px rgba(255, 165, 0, 0.6)"
                                            : "none",
                            transition: "all 0.5s ease-in-out",
                            animation: "fadeIn 1s ease-in-out"
                        }}
                    >
                        {status === "loading" && "⏳ Checking subscription..."}
                        {status === "active" && (
                            <>
                                ✅ Plan expires on: {expiryDate} <br />
                                ⏳ {remainingDays} days remaining
                            </>
                        )}

                        {status === "expired" && "🚫 Your Plan is Expired"}
                        {status === "error" && "⚠️ Error fetching plan status"}

                        <style>
                            {`
                                @keyframes fadeIn {
                                    from { opacity: 0; transform: scale(0.9); }
                                    to { opacity: 1; transform: scale(1); }
                                }
                            `}
                        </style>
                    </strong>

                    <div className="mt-5">
                        <img
                            src={status === "active" ? "/images/Data extraction-cuate.svg" : "/images/Data extraction-cuate.svg"}
                            alt={status === "active" ? "Active Plan" : "Expired Plan"}
                            width="800"
                            className="img-fluid"
                        />
                    </div>
                </div>

                <div className="col-md-6 d-flex justify-content-center mb-5 mb-md-0">
                    <PaymentCard />
                </div>
            </div>
        </div>
    );
};

export default Premium;
